import { render, staticRenderFns } from "./SelectedActionsDropdown.vue?vue&type=template&id=b88144b6&scoped=true"
import script from "./SelectedActionsDropdown.vue?vue&type=script&lang=js"
export * from "./SelectedActionsDropdown.vue?vue&type=script&lang=js"
import style0 from "./SelectedActionsDropdown.vue?vue&type=style&index=0&id=b88144b6&scoped=true&lang=scss"
import style1 from "./SelectedActionsDropdown.vue?vue&type=style&index=1&id=b88144b6&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88144b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b88144b6')) {
      api.createRecord('b88144b6', component.options)
    } else {
      api.reload('b88144b6', component.options)
    }
    module.hot.accept("./SelectedActionsDropdown.vue?vue&type=template&id=b88144b6&scoped=true", function () {
      api.rerender('b88144b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser-product-selector/SelectedActionsDropdown.vue"
export default component.exports